import { Modal } from '@studiometa/ui';

/**
 * Popin Newsletter class.
 */
export default class PopinNewsletter extends Modal {
  static config = {
    name: 'PopinNewsletter',
    refs: ['btnClose', 'input'],
    options: {
      delay: {
        type: Number,
        default: 7000,
      },
    },
  };

  /**
   * Mounted
   */
  mounted() {
    if (sessionStorage.getItem('newsletter_displayed')) {
      return;
    }

    setTimeout(() => {
      this.showPopin();
    }, this.$options.delay);
  }

  /**
   * Close when press Escape key
   * @param  {object} options key
   * @param  {object} options.ESC key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (this.opened && ESC) {
      this.closePopin();
    }
  }

  /**
   * Close on click
   * @returns {void}
   */
  onBtnCloseClick() {
    this.closePopin();
  }

  /**
   * Show Popin
   * @returns {void}
   */
  showPopin() {
    this.opened = true;
    this.$el.classList.remove('opacity-0', 'pointer-events-none');
    this.$refs.input.focus();
    document.documentElement.classList.add('overflow-hidden');
  }

  /**
   * Close popin
   * @returns {void}
   */
  closePopin() {
    sessionStorage.setItem('newsletter_displayed', true);
    this.opened = false;
    this.$el.classList.add('opacity-0', 'pointer-events-none');
    document.documentElement.classList.remove('overflow-hidden');
  }
}
